export default __webpack_public_path__ + "static/media/3.2ecf0000.md";